<template>
    <ul
        v-if="data.length"
        class="data-list"
        :class="{
            'bsdc:w-full bsdc:flex bsdc:max-sm:flex-wrap bsdc:max-sm:gap-y-2 bsdc:sm:gap-5': version === 1,
            'bsdc:w-full': version === 2,
            'bsdc:text-[13px]': size !== 'small',
            'bsdc:text-[11px]': size === 'small',
        }"
    >
        <template
            v-for="(item, index) in data"
            :key="index"
        >
            <li
                class="data-list__item bsdc:list-none bsdc:[&_.bsdc-tooltip]:-mb-[5px] bsdc:[&_.bsdc-tooltip]:relative bsdc:[&_.bsdc-tooltip]:-top-[1px] bsdc:[&_.bsdc-tooltip]:ml-1.5"
                :class="{
                    'bsdc:flex bsdc:flex-col bsdc:w-[50%] bsdc:sm:w-[16.66%]': version === 1,
                    'bsdc:mb-2 bsdc:pb-2 bsdc:border-b bsdc:border-solid bsdc:border-2-1 bsdc:flex bsdc:gap-5 bsdc:basis-0 bsdc:grow': version === 2,
                    'bsdc:mb-2 bsdc:flex bsdc:gap-5 bsdc:basis-0 bsdc:grow': version === 3,
                }"
                v-if="item.value"
            >
                <span :class="{
                    'bsdc:subtitle bsdc:text-[11px]': version === 1,
                    'bsdc:w-1/2': version === 2 || version === 3,
                    'bsdc:font-bold': size !== 'small' && version === 2,
                    'bsdc:text-typography-body/60': size === 'small',
                }">
                    {{ item.label }}
                    <Tooltip
                        v-if="item.tooltip"
                        :text="item.tooltip"
                    />
                </span>
                <span :class="{
                    'bsdc:text-[13px]': version === 1,
                    'bsdc:w-1/2 bsdc:mt-1.5': version === 2 || version === 3,
                }">
                    {{ item.value }}
                </span>
            </li>
        </template>
    </ul>
</template>

<script setup>
    import Tooltip from "@js/Components/Tooltip.vue";

    defineProps([
        'data',
        'version',
        'size',
    ]);
</script>
